const advertise = {
  dfdh: '对方电话:',
  sjmc: '商家名称',
  qsrsj: '请输入商家名称',
  sjbzj: '商家保证金',
  wcl: '30日完成率',
  zcd: '总成单（买/卖）',
  cd: '30日成单',
  c: '次',
  fz: '分钟',
  pjfx: '平均放行',
  zcsj: '注册时间：',
  fbjy: '首次访问法币交易:',
  yxbd: '邮箱绑定',
  sjbd: '手机绑定',
  cjsm: '初级实名认证',
  gjsm: '高级实名认证',
  buy: '购买',
  sell: '出售',
  market: '市场',
  djfs: '定价方式',
  ggid: '广告ID',
  time: '时间',
  type: '类型',
  ptgg: '普通广告',
  gdjg: '固定价格',
  fdjg: '浮动价格',
  yjfw: '溢价范围',
  unitPrice: '单价',
  totalPrice: '总价',
  sysl: '剩余数量',
  ywcsl: '已完成数量',
  cz: '操作',
  xj: '下架',
  sj: '上架',
  edit: '编辑',
  delete: '删除',
  all: '全部',
  qdxjm: '确认要下架本条广告吗？',
  qdxj: '下架确定',
  qdsjm: '确认要上架本条广告吗？',
  qdsj: '上架确定',
  confirm: '确定',
  cancel: '取消',
  qdscm: '确认要删除本条广告吗？',
  deleteAdvertise: '删除广告',

  tjgm: '统计购买',
  tjcs: '统计出售',
  coins: '币种',
  day7: '7天',
  day15: '15天',
  day30: '30天',
  tj: '统计',
  mrsl: '买入数量',
  mcsl: '卖出数量',
  mrjj: '买入均价',
  mcjj: '卖出均价',
  zcje: '支出金额',
  srje: '收入金额',
  zsxf: '总手续费',
  cjdd: '成交订单',
  zdxx: '账单信息',
  tips: '提示：每种交易对，买卖统计每天只能分别导出100次',
  dcdd: '导出订单',
  orderNo: '订单号',
  jybz: '交易币种',
  number: '数量',
  total: '总额',
  fee: '手续费',
  zd: '账单',

  tjskfs: '添加收款方式',
  skfs: '收款方式',
  name: '姓名',
  payAccount: '账户',
  sk: '收款',
  cz: '操作',
  delete: '删除',
  edit: '修改',
  qdsc: '确定删除?',
  tip: '提示',
  deleted: '已取消删除',
  xzskfstt: '新增收款方式',
  xgskfstt: '修改收款方式',
  khmc: '开户姓名',
  yhkh: '银行卡号',
  khh: '开户行',
  khhszd: '开户行所在地',
  khhmc: '开户行名称',
  wxzh: '微信账户',
  zfbzf: '支付宝支付',
  ewmsc: '二维码上传',
  jymm: '交易密码',
  srkhh: '请输入开户行',
  xzszd: '请选择开户行所在地',
  srkhmc: '请输入开户行名称',
  srzh: '请输入账号',
  scskm: '请上传收款码',
  srjymm: '请输入交易密码',
  scwjgd: '上传头像图片大小不能超过 2MB!',

  jnbzj1: '您作为{gradeName}， 已缴纳保证金{margin} USDT， 当前剩余广告额度{amount} USDT',
  k: '可',
  add: '追加',
  or: '或者',
  reduce: '减少',
  margin: '保证金',
  sqsxf: '*平台会向商家收取广告成交额的{fee}%作为手续费',
  hqed: '立即成为认证商家获得更高限额',
  want: '我想',
  bb: '币币',
  price: '价格',
  ckj: '*市场参考价{price} {fiatCurrency}/USDT 固定价格不会随市场波动',
  jyjg: '交易价格',
  mdjg: '锚定价格',
  gxhl: '*综合银行及多家交易所实时汇率，每5分钟更新一次',
  szyj: '设置溢价',
  zjjy: '*可输入负数，即在锚定价格基础上折价交易',
  yjsz: '*交易价格=锚定价格*（1+溢价设置）',
  jyxz: '交易限制',
  jysl: '交易数量',
  sygged: '*交易数量不可超过当前剩余广告额度',
  zxxe: '最小单笔限额',
  zdxe: '最大单笔限额',
  fkqx: '付款期限',
  xnfk: '*需在此时限内付款',
  fkfs: '付款方式',
  xzskfs: '*全部币种最多可增加5种收款方式',
  yhjy: '不与未完成高级实名认证的用户交易',
  jygg: '*仅完成初级实名认证的用户不能进入交易广告',
  cyjy: '请选择未完成指定购买次数的用户，不能参与交易',
  bmfx: '*完成过购买的用户，已大大降低资金来源不明的风险',
  qxz: '请选择',
  jybz: '交易备注',
  tyzs: '我已知晓并同意遵守',
  jygz: '《交易规则》',
  yzm: '验证码',
  save: '保存',
  fbgg: '发布广告',
  jsbzjcg: '减少保证金成功',
  zjbzjcg: '追加保证金成功',
  xzfs: '请选择收款方式或付款方式',
  bankTip1: '银行卡不能超过三种收款方式',
  wxTip2: '微信不能超过三种收款方式',
  zfbTip3: '支付宝不能超过三种收款方式',
  syjg: '请输入价格',
  syjysl: '请输入交易数量',
  zxxe: '请输入最小单笔限额',
  zdxe: '请输入最大单笔限额',
  fkqx: '请输入付款期限',
  tyjygz: '请同意交易规则',
  tpyzm: '请输入图片验证码',
  jydx: '交易对象',

  zjbzj: '追加保证金',
  jsbzj: '减少保证金',
  xzdgged: '现最大广告额度',
  zjbzjse: '追加保证金数额',
  jsbzjse: '减少保证金数额',
  zjhbzjed: '追加后保证金额度',
  jshbzjed: '减少后保证金额度',
  balance: '余额',
  sy: '剩余',
  kzj: '可追加',
  kjs: '可减少',
  otcsjxy: 'OTC商家服务规则协议',
  xsgz: '新手教程',
  jygz: '交易规则',
  jnbzj: '为保证OTC合法合规，规范相关各方行为，因此要求商家缴纳一定数额保证金；',
  zjjnbzj: '保证金分为基础额度和追加额度两部分组成，基础额度为必需缴纳部分，追加部分可选则缴纳或不缴；',
  kxs: '缴纳基础额度可享受',
  fbgged: '发布CNYT则按汇率计算）的广告额度；',
  ggedbl: '追加部分的保证金与广告额度比例为',
  eg: '如追加100 USDT 则广告额度在基础额度上增加 100 x',
  ggzedjs: '广告总额度的计算公式为：基础广告额度+追加广告额度 x',
  ttsjzxed: '普通商家追加保证金最小额度为',
  zdedw: '最大额度为',
  mgsjzd: '每个商家最多可以发布三条购买广告和三条出售广告。',
  hljj: 'USDT兑CNYT的汇率取自BiKing平台相关交易对过去24小时的均价（每小时记录一次，并去掉了最高价与最低价），作为当前的汇率值；并且当汇率出现波动时，原先发布的广告额度保持不变。',
  jcbzj: '基础保证金',
  xt: '选填',
  njhded: '您将获得的广告额度为：',
  mbye: '买币余额：',
  zhzcbz: '账户资产不足，您可以从资产账户划转',
  qhz: '去划转',
  qdjnbzj: '确定缴纳基础保证金',
  tjbzj: '添加保证金',
  sqsjcg: '申请商家成功',
  exchange:'汇率切换'
}
export {
    advertise
}


// WEBPACK FOOTER //
// ./src/i18n/lang/advertise/zh.js